import { CommissionDetailsContext } from '~/context/commissionDetails'
import { useContext } from 'react'

const useCommissionDetails = () => useContext(CommissionDetailsContext)

export default useCommissionDetails
